import '@tencent/tpm-meeting/lib/ComHero/style';
import React, { useContext } from 'react';
import styles from './index.module.scss';
import ProductDetailContext from '../../context/ProductDetailContext';
import { PackageNodeTypePatch, PatchPageList } from '@/tpss/types';
import { Link, PrimaryTable } from 'tdesign-react';
import { convertDBTimestampToDateStr } from '@/tpss/utils/utils';
import { useNavigate, useParams } from 'react-router-dom';

const ProductPatchList: React.FC = () => {
  // const [packages, setPackages] = useState<ProductPackage[]>([]);
  const currentPatchList = useContext(ProductDetailContext).currentPatchList;
  const { choosePatchPackageNode } = useContext(ProductDetailContext);
  const { currentSoftwareType } = useContext(ProductDetailContext);
  const { patchPage } = useContext(ProductDetailContext);
  const { currentBaseline } = useContext(ProductDetailContext);
  const { id } = useParams();
  const navigate = useNavigate();

  function onPatchItemClick(row) {
    // console.log(row);
    navigate(`/product/${id}/package/${row.ID}`);
    choosePatchPackageNode(row);
  }

  const patchColomns = [
    { colKey: 'ProductPackageNodeName', title: '名称' },
    { colKey: 'ProductPackageNodeDescription', title: ' 描述' },
    {
      colKey: 'createTime',
      title: '发布时间',
      cell: ({ row }) => convertDBTimestampToDateStr(row.CreatedAt)
    },
    {
      colKey: 'manipulate',
      title: '操作',
      cell: ({ row }) => (
        <Link theme="primary" hover="color" onClick={() => onPatchItemClick(row)}>
          查看详情
        </Link>
      )
    }
  ];
  function patchListNeedDisplay() {
    if (
      currentSoftwareType === PackageNodeTypePatch &&
      patchPage === PatchPageList
    ) {
      return true;
    }
    return false;
  }

  return (
    <div
      style={{
        display: patchListNeedDisplay() ? 'block' : 'none'
      }}
    >
      <div>
        <div className={styles.patchListTitle}> {currentBaseline} - 补丁包列表</div>
      </div>
      <PrimaryTable
        className={styles.customHeaderBg}
        columns={patchColomns}
        data={currentPatchList}
        rowKey="index"
        size="medium"
        tableLayout="fixed"
        verticalAlign="middle"
      />
    </div>
  );
};

export default ProductPatchList;
